import React from "react";
import Indicator from "src/components/layout/Indicator";

interface NavItemIconProps {
	count?: number | null;
	icon?: string | JSX.Element;
	loading?: boolean;
}

const NavItemIcon = ({ count, icon, loading }: NavItemIconProps) => {
	return (
		<div className="w-6 lg:w-auto xl:w-6 relative md:mx-0 lg:mx-auto xl:mx-0">
			{count ? (
				<Indicator
					style={{
						top: -6,
						right: -10,
					}}
					className="absolute"
				>
					{count}
				</Indicator>
			) : (
				false
			)}
			{loading ? (
				<span className="base-loader"></span>
			) : typeof icon === "string" ? (
				<i className={`${icon}`}></i>
			) : (
				icon
			)}
		</div>
	);
};

export default NavItemIcon;
